/**
 * Tenant Blocked Slice
 * Drives the global "workspace is read-only" dialog (see TenantBlockedDialog.tsx).
 * Sibling to permissionLockSlice.ts — same open/payload/show/hide shape — but for
 * a workspace that is suspended or inactive rather than a role/plan denial.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TenantBlockedPayload } from '@/utils/tenant-block-detection.util';

export interface TenantBlockedState {
  open: boolean;
  payload: TenantBlockedPayload | null;
}

const initialState: TenantBlockedState = {
  open: false,
  payload: null,
};

const tenantBlockedSlice = createSlice({
  name: 'tenantBlocked',
  initialState,
  reducers: {
    showTenantBlocked: (state, action: PayloadAction<TenantBlockedPayload>) => {
      state.open = true;
      state.payload = action.payload;
    },
    hideTenantBlocked: (state) => {
      state.open = false;
    },
  },
});

export const { showTenantBlocked, hideTenantBlocked } = tenantBlockedSlice.actions;
export default tenantBlockedSlice.reducer;
